import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Route } from 'react-router-dom';
import { initPlatformConfig, isOt, isProd } from '@chat/utils';
import { setbaseconfig } from '@/redux/index/action';
import { defaultVariables, getConfigData } from '@/config/config';

function RouteWrapper({ path = '', component: Component = null }): JSX.Element {
    const dispatch = useDispatch();
    const [isLoading, setLoading] = useState(true);
    const [code, setCode] = useState(0);

    /** 获取游戏配置 */
    const getConfig = async () => {
        try {
            await IM.SDKServer.getSSO();
            const { game_key } = IM.SDKServer.getState();
            const res = await getConfigData(game_key);
            // if (res.data.d?.redirect_url) {
            //     window.location.replace(res.data.d.redirect_url);
            //     return;
            // }
            if (res.data.d?.game?.service_type === 2) {
                IM.SDKServer.setVip(true);
            }
            // IM.SDKServer.setVip(true);
            await initPlatformConfig({
                config: res.data.d,
                executeDone: true,
                defaultVariables
            });
            dispatch(setbaseconfig(res.data.d));
            document
                .querySelectorAll('html')[0]
                .setAttribute('data-skin', res.data.d?.game?.service_type === 2 ? 'vip' : 'base');
            // document.querySelectorAll('html')[0].setAttribute('data-skin', 'vip');
        } catch (error) {
            console.log(error);
            setCode(error.c);
        } finally {
            setLoading(false);
            window?.IMBridge?.customerRightContainer?.();
        }
    };

    useEffect(() => {
        // if (isOt || isProd) {
        //     const { game_key, platform } = IM.SDKServer.getState();
        //     if (platform === '4399yy' || platform === 'zhkf') {
        //         window.location.replace(`/kf/im/${game_key}`);
        //         return;
        //     }
        //     getConfig();
        // } else {
        getConfig();
        // }
    }, []);

    return (
        <Route
            path={path}
            component={(rest) => <Component code={code} isLoading={isLoading} {...rest} />}
        />
    );
}

export default RouteWrapper;
